import { css } from "@emotion/react";

const input = props => css`
  width: 100%;

  @media (min-width: ${props.theme.screenSizes.mdMax}) {
    width: 320px;
  }
`;

const button = css`
  padding: 24px 32px;
`;

export const addStyles = {
  input,
  button,
};
